export { default as ContentEmbed } from './ContentEmbed';
